/** 潜客管理 */

// 潜客列表
export const POSTENTIAL_LIST_NEW = '/ccrm2/user/listNew';
// 获取会员来源列表
export const SUPPORT_GET_SOURCE = '/ccrm2/support/getSource';
// 查询潜客信息-旧平台
export const POTEN_INFO_OLD = '/ccrm2/user/getUserInfo';
// 查询潜客消费信息
export const POTEN_CONSUME_OLD = '/ccrm2/user/getOrderInfo';
